/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import { Card } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import NewEvaluoExam from './NewEvaluoExam';
import { Loading } from '../../../../helpers/utils';

import groupServices from '../../../../redux/services/groupServices';
import semesterServices from '../../../../redux/services/semesterServices';
import companyServices from '../../../../redux/services/companyServices';
import ListEvaluoExam from './ListEvaluoExam';
import evaluoServices from '../../../../redux/services/evaluoServices';

const Evaluo = ({ company }) => {
  const [examData, setExamData] = useState([]);
  const [semestersList, setSemestersList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const [subjects, setSubjects] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const getCompanyData = () => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setType(res.adminData.type);
      });
  };

  const getSubjects = async () => {
    const resSubjects = await evaluoServices.getSubjects();
    if (resSubjects && resSubjects.length > 0) {
      setSubjects(resSubjects);
    }
  };

  const getSemesters = async () => {
    semesterServices.getAllSemesters()
      .then((allSemesters) => {
        const semesterArr = [];
        allSemesters.forEach((sem) => {
          if (sem.value > 2 && sem.value < 7 && sem.schoolTypes.includes(type)) {
            semesterArr.push(sem);
          }
        });
        const newArr = semesterArr
          .sort((a, b) => a.value - b.value)
          .filter((item) => !item.label.includes('Rattrapages'));
        setSemestersList(newArr);
      });
  };

  const getExamData = () => {
    groupServices.getGroupsDataByCompagny(company._id)
      .then((res) => {
        const tmp = [];
        setGroups(res);
        if (res.data) {
          const groupArr = Object.values(res.data);
          groupArr.forEach((group) => {
            if (group.elearning
              && group.elearning.elearningOptions
              && group.elearning.elearningOptions.length > 0
              && group.level === 1) {
              group.elearning.elearningOptions.forEach((option) => {
                tmp.push({ ...option, semester: group.semester });
              });
            }
          });
        }
        setExamData(tmp);
        setLoading(false);
      });
  };

  useEffect(() => {
    getSemesters();
    getSubjects();
    getExamData();
  }, [type]);

  useEffect(() => {
    getCompanyData();
  }, []);

  return (
    <>
      {loading === false
        ? (
          <>
            <Card>
              <NewEvaluoExam
                company={company}
                examData={examData}
                setExamData={setExamData}
                semestersList={semestersList}
                setRefresh={setRefresh}
                refresh={refresh}
                setLoadingList={setLoadingList}
                allSubjects={subjects}
              />
            </Card>
            <ListEvaluoExam
              company={company}
              semestersList={semestersList}
              setRefresh={setRefresh}
              refresh={refresh}
              loadingList={loadingList}
              setLoadingList={setLoadingList}
              allSubjects={subjects}
            />
          </>
        )
        : <Loading />}
    </>
  );
};

Evaluo.propTypes = {
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedEvaluo = connect(mapState, null)(Evaluo);

export default withRouter(connectedEvaluo);
